import { useLocation } from 'react-router-dom'

import { Box, Icon, ProgressBar, Table, Tag, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type GoalConfig from 'modules/goals/store/models/GoalConfig'
import { STATUS } from 'modules/goals/store/models/GoalConfig'

import Owners from '../_Owners'

interface BodyProps {
  filteredGoalsConfigCollection: GoalConfig[]
}

const Body = ({ filteredGoalsConfigCollection }: BodyProps) => {
  const { navigation } = useNavigation()

  const location = useLocation()
  const { id } = useStrictParams<'id'>()

  const tagType = (status: string) => {
    return status === STATUS.active ? Tag.Types.lime : Tag.Types.malibu
  }

  const tagCopy = (status: string) => {
    return status === STATUS.active
      ? i18n.t('surveys.goals.show.active')
      : i18n.t('surveys.goals.show.closed')
  }

  const displayDate = (date: string) => (date ? dateBackendDateTimeToUI(date) : '-')

  if (!filteredGoalsConfigCollection.length) {
    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={13}>
            <Box alignItems="center" paddingY="s24">
              <Text size="300">{i18n.t('surveys.goals.table.empty')}</Text>
            </Box>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    )
  }

  const { pathname } = location

  const goalPath = (pathname: string, goalConfig: GoalConfig) => {
    switch (pathname) {
      case navigation.goals.fullPath():
        return navigation.goals.id.fullPath({ id: goalConfig.id })

      case navigation.employees.id.goals.fullPath({ id }):
        return navigation.employees.id.goalsGoalConfigId.fullPath({
          id,
          goal_config_id: goalConfig.id,
        })

      default:
        return navigation.performance.goals.id.fullPath({ id: goalConfig.id })
    }
  }

  return (
    <Table.Body>
      {filteredGoalsConfigCollection.map((goalConfig) => (
        <Table.Row.Router key={goalConfig.attributes.id} to={goalPath(pathname, goalConfig)}>
          <Table.Cell colSpan={3}>
            <Text.Normal weight="medium">{goalConfig.attributes.name}</Text.Normal>
          </Table.Cell>
          <Table.Cell colSpan={2}>
            {goalConfig.attributes.owner_ids.length ? (
              <Owners owners={goalConfig.attributes.owner_ids} />
            ) : (
              '-'
            )}
          </Table.Cell>
          <Table.Cell colSpan={2}>
            <Text size="200">{displayDate(goalConfig.attributes.due_date)}</Text>
          </Table.Cell>
          <Table.Cell colSpan={2}>
            <Box
              style={{
                width: 'fit-content',
              }}
            >
              <Tag leftItem="circle" showCircle type={tagType(goalConfig.attributes.status)}>
                {tagCopy(goalConfig.attributes.status)}
              </Tag>
            </Box>
          </Table.Cell>
          <Table.Cell colSpan={2}>
            {goalConfig.isNumeric && (
              <ProgressBar
                percentage={goalConfig.attributes.progress_percentage}
                total={100}
                amount={goalConfig.attributes.progress_percentage}
              />
            )}
          </Table.Cell>
          <Table.Cell colSpan={1}>
            <Icon.Medium icon="arrow-right" />
          </Table.Cell>
        </Table.Row.Router>
      ))}
    </Table.Body>
  )
}

export default Body
